import React from "react";
import Dashboard from "components/Template/Dashboard";
// import Button from "components/Button";
import { ReactComponent as Edit } from "icons/edit-white.svg";

type Props = {};

const PaymentsIndex: React.FC<Props> = (): JSX.Element => {
  return (
    <Dashboard
      title={"Payments"}
      breadcrumb={[]}
      subInfo={""}
      children={
        <div className="flex flex-row w-full">
          <a
            type="button"
            href="https://dashboard.stripe.com/login"
            target="_blank"
            className="bg-bt-green text-bt-white h-14 w-64 rounded-full"
            rel="noreferrer"
          >
            <div className="flex flex-row justify-center">
              <div className="flex flex-col mt-3">
                <Edit width={30} height={30} />
              </div>
              <div
                className="flex flex-col mt-4 ml-2 font-sora text-base"
                style={{
                  fontStyle: "normal",
                  fontWeight: 600,
                }}
              >
                Manage Plans on Stripe
              </div>
            </div>
          </a>
        </div>
      }
    />
  );
};

export default PaymentsIndex;
